<div class="card kpi-info">
    <div class="card-body kpi-card">
        <h5 class="card-title">Taux de chômage</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- %</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.ad_city.carac_commune.T_chom * 100| number: '1.1-1' }} %
            </ng-container>
        </p>
    </div>
</div>
